export default __webpack_public_path__ + "js/components/liveClassPurchasePage/component/BenefitScreen/table-gradient-ab960b5a2eddeca75b23db9a7426e9a4.svg";